import type { BackofficeClient } from "@/api/backoffice-v2/backoffice-client";
import type { Env } from "@/env-schema";
import type { App, Plugin } from "vue";

import { inject } from "vue";

import { makeSdkBackofficeClient } from "@/api/backoffice-v2/backoffice-client-sdk";
import {
  makeSdkSubscriberBackendClient,
  SubscriberBackendClient,
} from "@/api/subscriber-backend/subscriber-backend-client-sdk";

export interface IServices {
  env: Env;
  backofficeClient: BackofficeClient;
  subscriberBackendClient: SubscriberBackendClient;
}

export function createServices(env: Env): IServices {
  const backofficeClient = makeSdkBackofficeClient(env);
  const subscriberBackendClient = makeSdkSubscriberBackendClient(env);

  return {
    env,
    backofficeClient,
    subscriberBackendClient,
  };
}

const SERVICES_KEY = Symbol("app-services");

export const provideServicesPlugin: Plugin = {
  install(app: App, options: { services: IServices }) {
    app.provide<IServices>(SERVICES_KEY, options.services);
  },
};

export function useServices(): IServices {
  const services = inject<IServices>(SERVICES_KEY);
  if (!services) {
    throw new Error("Services not provided");
  }
  return services;
}
